// extracted by mini-css-extract-plugin
export default {"form":"EditarCliente_form__1cTEN","areaBtn":"EditarCliente_areaBtn__oWylC","btn":"EditarCliente_btn__WZ1n5"};